module.exports = __webpack_public_path__ + "static/img/64-3.75fb864.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/64-3.jpg
// module id = 1E/p
// module chunks = 0